module.exports = __webpack_public_path__ + "na.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/na.svg
// module id = 977
// module chunks = 0